import {ofType} from 'redux-observable';
import {of, from} from 'rxjs';
import {mergeMap, catchError} from 'rxjs/operators';
import {type ApolloQueryResult} from '@apollo/client';
import {type List} from 'immutable';

import {combineEpics} from 'web-app/util/redux-observable';
import {getApolloClient} from 'web-app/api/clients/famly-app';
import {type RoleTarget, type RoleSource} from 'web-app/util/graphql/api-types';
import type * as Types from 'web-app/react/manage-employees/roles/permission-role-form/types';

import {TEMP_ROLE_ID} from '../constants';
import * as Actions from './actions';
import * as Queries from './queries';
import {type GetRolesAndPermissionsQuery} from './__generated__/queries.api-types';

const fetchDataObservable = (
    institutionSetId: string,
    source: RoleSource,
    target: RoleTarget,
    roleIds?: List<string>,
    mode?: Types.PermissionRoleFormMode,
) => {
    return from(
        getApolloClient().query({
            query: Queries.GetRolesAndPermissions,
            variables: {
                institutionSetIds: [institutionSetId],
                source,
                target,
                roleIds: roleIds ? roleIds.toArray() : null,
                first: 1000,
            },
            fetchPolicy: 'network-only',
        }),
    ).pipe(
        mergeMap((result: ApolloQueryResult<GetRolesAndPermissionsQuery>) => {
            const duplicating = mode === 'duplicate';
            const creating = mode === 'create';

            const roles =
                duplicating || creating
                    ? [
                          {
                              id: TEMP_ROLE_ID,
                              roleId: TEMP_ROLE_ID,
                              title: TEMP_ROLE_ID,
                              locked: false,
                              source,
                              target,
                              institutionSetIds: [institutionSetId],
                              permissions: result.data.roles.list.roles[0].permissions.map(permission => {
                                  return {
                                      permissionId: permission.permissionId,
                                      granted: creating ? false : permission.granted,
                                      // The user can only assign permissions they have them selves
                                      locked: creating ? !permission.granted : permission.locked,
                                  };
                              }),
                          },
                      ]
                    : result.data.roles.list.roles;

            return of(Actions.setInitialState.action(result.data.roles.list.permissions, roles));
        }),
    );
};

const fetchData = action$ =>
    action$.pipe(
        ofType(Actions.fetchData.type),
        mergeMap(({payload}) => {
            return fetchDataObservable(
                payload.institutionSetId,
                payload.source,
                payload.target,
                payload.roleIds,
                payload.mode,
            );
        }),
        catchError(error => {
            return of(Actions.fetchDataFailed.action(error));
        }),
    );

export default combineEpics(fetchData);
